import React, { SVGProps, useEffect, useRef } from 'react';
import { gsap, DrawSVGPlugin } from 'gsap/all';

import { useWindowSize } from '../../hooks/use-window-size';
import { BREAKPOINT, isMobileResolution } from '../../helpers/layout.helper';

import s from './Play.module.scss';


interface IPlay {
  watchVideoText: string;
  svgProps?: SVGProps<any>;
  isBlack?: boolean;
  onClick?: () => void;
}

export const Play = (props: IPlay) => {
  const {
    watchVideoText,
    svgProps,
    onClick,
    isBlack = false,
  } = props;
  const refPlay = useRef<SVGPathElement>(null);
  const refCircle = useRef<SVGCircleElement>(null);

  const windowSize = useWindowSize();
  const isMobile = isMobileResolution(windowSize, BREAKPOINT.TABLET);

  const outlineCircleOn = () => {
    if (refPlay.current && refCircle.current) {
      gsap.to(refPlay.current, {
        scale: 1.1,
        duration: .4,
        transformOrigin: '50% 50%',
      });
      gsap.to(refCircle.current, {
        drawSVG: `100%`,
        duration: 1.5,
        ease: 'power3',
        opacity: 1,
        rotation: '+=90',
        transformOrigin: 'center',
      });
    }
  };

  const outlineCircleOff = () => {
    if (refPlay.current && refCircle.current) {
      gsap.to(refPlay.current, {
        scale: 1,
        transformOrigin: '50% 50%',
      });
      gsap.to(refCircle.current, {
        drawSVG: `0%`,
        duration: 2,
        ease: 'expo',
        opacity: 0,
        rotation: '-=180',
        transformOrigin: 'center',
      });
    }
  };

  useEffect(() => {
    gsap.registerPlugin(DrawSVGPlugin);
    if (refPlay.current && refCircle.current) {
      outlineCircleOff();
    }
  }, []);

  return (
    <div
      className={`${s.play} ${isBlack ? s.black : ''}`}
      onMouseOver={outlineCircleOn}
      onMouseLeave={outlineCircleOff}
      onClick={onClick}
    >
      <svg
        width={isMobile ? 63 : 163}
        height={isMobile ? 63 : 163}
        viewBox="0 0 163 163"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={s.play__svg}
        {...svgProps}
      >
        <circle
          cx={81.5}
          cy={81.5}
          r={80.75}
          stroke="#fff"
          strokeOpacity={0.4}
          strokeWidth={1.5}
        />
        <circle
          cx={81.5}
          cy={81.5}
          r={80.75}
          stroke="#fff"
          strokeWidth={1.5}
          ref={refCircle}
        />
        <path
          d="M70.295 53.748c0-4.24 4.945-6.555 8.201-3.84l31.047 25.881a5 5 0 010 7.681l-31.047 25.882c-3.256 2.714-8.2.399-8.201-3.841V53.748z"
          fill="#fff"
          ref={refPlay}
        />
      </svg>
      <span className={s.play__text}>{watchVideoText}</span>
    </div>
  );
};
